/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

// Contentstack colors may be a raw hex string or a color picker object with a `hex` field
export const resolveColor = (color: unknown): string | undefined => {
  if (typeof color === 'string') {
    return color;
  }
  if (
    typeof color === 'object' &&
    color !== null &&
    'hex' in color &&
    typeof color.hex === 'string'
  ) {
    return color.hex;
  }
  return undefined;
};
